import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "Here we describe stepwise how to design a listening experiment. Such an experiment is usually created in order to check a hypothesis, which is based on an initial observeration. Each step requires decisions of the experiment designer.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 3,
      rowsSize: [1, 4, 2],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "<b>Questions to be considered while creating an intial study design</b>",
                  formatter: "html",
                  scrollbars: false,
                },
              },
              styles: {
                fontSize: "18px",
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/02/23/principle/principle-7-content.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "hint",
                options: {
                  data:
                    "Once an intial study design was chosen, pre-testing with persons, who have not been involved in the planning of study, is recommended. The feedback of these persons will help to finalize the design and make it more robust.",
                  size: "large-thin",
                  color: "primary",
                  direction: "row",
                },
              },
              styles: {
                padding: "1% 0 4% 0",
                maxWidth: "70%",
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
